module Bookhus.Widgets {

    export class BookingPossibilities {
        private culture: string;
        private houseId: number;
        private containerId: string;
        private dontShowPrice: boolean;
        private arrivalTitle: string;
        private departureTitle: string;
        private hasEventModule: boolean;
        private queueListDefaultText: string;
        private showBookingType: boolean;
        private isReloading: boolean;
        private activeRequestId: number;
        private pendingReload: { startdate: Date; enddate: Date } = null;

        constructor(houseId: number, culture: string, containerId: string, dontShowPrice: boolean = true, arrivalTitle: string, departureTitle: string, hasEventModule: boolean, queueListDefaultText: string, showBookingType: boolean) {
            this.containerId = containerId;
            this.culture = culture;
            this.houseId = houseId;
            this.dontShowPrice = dontShowPrice;
            this.arrivalTitle = arrivalTitle;
            this.departureTitle = departureTitle;
            this.hasEventModule = hasEventModule;
            this.queueListDefaultText = queueListDefaultText;
            this.showBookingType = showBookingType;
            this.isReloading = false;
            this.activeRequestId = 0;
        }

        private getButtonHtml(period: IBookingPossibility): string {
            var bookknaptekst = (window as any).Bookhus.Localization.Standard.UI.ButtonText.Book;
            var bookknapcss = "btn-success";

            if (period.type === 2) {
                bookknaptekst = (window as any).Bookhus.Localization.Standard.UI.ButtonText.Lock;
                bookknapcss = "btn-primary";
            } else if (period.isAlreadyBooked && !period.bookingtype.pricePerHour) {
                bookknaptekst = (window as any).Bookhus.Localization.Standard.UI.ButtonText.CancelationNotification;
                bookknapcss = "btn-info";
            } else if (period.type === 0) {
                bookknaptekst = (window as any).Bookhus.Localization.Standard.UI.ButtonText.Wish;
            }

            if (period.bookingtype.extraParameters != undefined && period.bookingtype.extraParameters.recurringSettings != undefined && period.bookingtype.extraParameters.recurringSettings.enabled) {
                bookknaptekst = (window as any).Bookhus.Localization.Standard.UI.ButtonText.BookSeries;
            }

            //else if (p.notOpenYet && p.openingDateRfc1123) {
            //    bookknaptekst = self.localizedStrings.notify[self.culture];
            //}

            if (period.type === 0 && this.hasEventModule) {
                bookknaptekst = (window as any).Bookhus.Localization.Standard.UI.ButtonText.Event;
                bookknapcss = "btn-success";
            }

            var buttonResult = '';
            if (period.isAlreadyBooked && !period.bookingtype.pricePerHour) {
                buttonResult = `
                    <form method="post" action="/book" class="form-inline w-100" id="waitListForm">
                        <input type="hidden" value="${period.bookingtype.houseid}" name="House.Id" id="House_Id" />
                        <input type="hidden" value="${period.isAlreadyBooked}" name="Bookingposibility.IsAlreadyBooked" id="Bookingposibility_IsAlreadyBooked" />
                        <input type="hidden" value="${period.type}" name="Bookingposibility.Type" id="Bookingposibility_Type" />
                        <input type="hidden" value="${period.arrivaldateRfc1123}" name="Bookingposibility.Arrivaldate" id="Bookingposibility_Arrivaldate" />
                        <input type="hidden" value="${period.departuredateRfc1123}" name="Bookingposibility.Departuredate" id="Bookingposibility_Departuredate" />
                        <input type="hidden" value="${period.bookingtype.id}" name="Bookingposibility.Bookingtype.Id" id="Bookingposibility_Bookingtype_Id" />
                        <input type="hidden" value="${period.bookingtype.bookingtypeDataId}" name="Bookingposibility.Bookingtype.BookingtypeDataId" id="Bookingposibility_Bookingtype_BookingtypeDataId" />
                        <input type="button" name="btnsubmit" value="${bookknaptekst}" class="btn ${bookknapcss} pl-md-0 pr-md-0 btn-block font-size-1 submitWaitingList" data-queuelength="${period.queueLength}" />
                    </form>
                `;
            }
            else if (period.notOpenYet) {
                buttonResult = `<button title="${period.notOpenYetText}" class="btn btn-warning pl-md-0 pr-md-0 btn-block font-size-1" disabled>${bookknaptekst}</button>`;
            }
            else {
                var IsPricePerHouse = (<any>period.bookingtype).pricePerHour || false;
                buttonResult = `
                    <form method="post" action="/book" class="form-inline w-100">
                        <input type="hidden" value="${period.bookingtype.houseid}" name="House.Id" id="House_Id" />
                        <input type="hidden" value="${period.isAlreadyBooked}" name="Bookingposibility.IsAlreadyBooked" id="Bookingposibility_IsAlreadyBooked" />
                        <input type="hidden" value="${period.type}" name="Bookingposibility.Type" id="Bookingposibility_Type" />
                        <input type="hidden" value="${period.arrivaldateRfc1123}" name="Bookingposibility.Arrivaldate" id="Bookingposibility_Arrivaldate" />
                        <input type="hidden" value="${IsPricePerHouse ? period.arrivaldateRfc1123 : period.departuredateRfc1123
                    } " name="Bookingposibility.Departuredate" id="Bookingposibility_Departuredate" />
                        <input type="hidden" value="${period.bookingtype.id}" name="Bookingposibility.Bookingtype.Id" id="Bookingposibility_Bookingtype_Id" />
                        <input type="hidden" value="${IsPricePerHouse}" name="Bookingposibility.Bookingtype.PricePerHour" id="Bookingposibility_Bookingtype_PricePerHour" />
                        <input type="hidden" value="${period.bookingtype.bookingtypeDataId}" name="Bookingposibility.Bookingtype.BookingtypeDataId" id="Bookingposibility_Bookingtype_BookingtypeDataId" />
                        <input type="submit" name="btnsubmit" value="${bookknaptekst}" class="btn ${bookknapcss} pl-md-0 pr-md-0 btn-block font-size-1"  ${IsPricePerHouse ? "disabled" : ""}/>
                    </form>
                `;
                //pl-md-0 pr-md-0 d-block btn font-size-1 btnGreen
            }
            return buttonResult;
        }

        public reload(startdate: Date, enddate: Date) {
            var self = this;
            if (self.isReloading) {
                self.pendingReload = { startdate: new Date(startdate), enddate: new Date(enddate) };
                return;
            }
            self.isReloading = true;
            const requestId = ++self.activeRequestId;
            const regional = $.datepicker.regional[self.culture] || $.datepicker.regional["da"] || $.datepicker.regional[""];
            const pad = n => n < 10 ? "0" + n : n;
            $("#" + self.containerId).html(`${(window as any).Bookhus.Localization.Standard.UI.Widgets.Bookingpossibilities.Loading} <i class="fas fa-spinner fa-spin"></i>`);
            $("#status").html('');
            $.getJSON("/api/booking/getbookingposibilities?houseId=" + this.houseId + "&startdate=" + startdate.formatDate("yy-mm-dd") + "&enddate=" + enddate.formatDate("yy-mm-dd") + ' ' + pad(enddate.getHours()) + ':' + pad(enddate.getMinutes()))
                .done((possibilities: IBookingPossibility[]) => {
                    if (self.activeRequestId !== requestId || self.pendingReload) {
                        return;
                    }
                    if (!possibilities || possibilities.length == 0) {
                        var customMessage = ((window as any).nopriceMessage || "").toString();

                        var noPossibilities =
                            customMessage.length > 0
                                ? customMessage
                                : (
                                    (window as any).Bookhus?.Localization?.Standard?.UI?.Widgets?.Bookingpossibilities?.NoPossibilities
                                    || (window as any).Bookhus?.Localization?.Standard?.UI?.Bookingpossibilities?.NoPossibilities
                                    || "Der er ingen ledige tider i den valgte periode."
                                );

                        $("#" + self.containerId).html(`
                            <div class="text-center mb-4">${noPossibilities}</div>
                        `);
                    }
                    else {
                        console.log("InventorymanagementIsEffect", possibilities);

                        var datesSelected: string[] = [];
                        var additionalMessage = "";
                        var possibilitiesHtml = "";

                        const inventoryCache: any = {};
                        const possibilityRequests: any[] = [];

                        const formatDateTime = (d: Date) => {
                            const pad = (n: number) => n < 10 ? "0" + n : n;

                            return d.getFullYear() + "-" +
                                pad(d.getMonth() + 1) + "-" +
                                pad(d.getDate()) + " " +
                                pad(d.getHours()) + ":" +
                                pad(d.getMinutes());
                        };

                        possibilities.forEach(p => {
                            if (p.type === -1) {
                                additionalMessage = p.notOpenYetText;
                                return;
                            }

                            var arrivaldate = new Date(p.arrivaldate);
                            var arrivaltime = arrivaldate.toString("HH:mm");

                            var departuredate = new Date(p.departuredate);
                            var departuretime = departuredate.toString("HH:mm");

                            if (p.type === 2) {
                                p.calculatedPriceString = "";
                            }

                            if (self.dontShowPrice) {
                                p.calculatedPriceString = "";
                            }

                            if (p.type === 0 && self.hasEventModule) {
                                p.calculatedPriceString = "";
                            }

                            const runBookingLogic = (inventoryCapacities: any[] = []) => {
                                var activeTimePeriods: any = (<any>p.bookingtype).timePeriods || [] as [];
                                activeTimePeriods = activeTimePeriods.filter((i: any) => { return i.active == true });

                                const arrivalDate = new Date(arrivaldate);
                                const departureDate = new Date(departuredate);

                                arrivalDate.setHours(0, 0, 0, 0);
                                departureDate.setHours(0, 0, 0, 0);
                                departureDate.setDate(departureDate.getDate() - 1);

                                for (let currentDate = new Date(arrivalDate); currentDate <= departureDate; currentDate.setDate(currentDate.getDate() + 1)) {

                                    const isDateAllowed = p.bookingtype.daysAllowedForTimePeriod.some(date => {
                                        var _date = new Date(date);
                                        return _date.setHours(0, 0, 0, 0) === currentDate.setHours(0, 0, 0, 0);
                                    });

                                    if (isDateAllowed) {
                                        var _currentDate = currentDate;
                                        var times = "";

                                        const arrivalTimeStr = arrivaltime;
                                        const departureTimeStr = departuretime;

                                        const [arrivalHours, arrivalMinutes] = arrivalTimeStr.split(':');
                                        const startTime = new Date(_currentDate.getFullYear(), _currentDate.getMonth(), _currentDate.getDate(), Number(arrivalHours), Number(arrivalMinutes), 0);

                                        const [departureHours, departureMinutes] = departureTimeStr.split(':');
                                        const endTime = new Date(_currentDate.getFullYear(), _currentDate.getMonth(), _currentDate.getDate(), (Number(arrivalHours) > Number(departureHours) ? 24 : 0) + Number(departureHours), Number(departureMinutes), 0);

                                        const hoursDiff = ((endTime.getTime() - startTime.getTime()) / (1000 * 60 * 60)) as number;

                                        var prices = p.bookingtype.prices.filter((i) => {
                                            return new Date(i.startdate) <= currentDate && currentDate <= new Date(i.enddate);
                                        })[0];

                                        if (prices == null) {
                                            prices = p.bookingtype.prices[0];
                                        }

                                        var price = "0";
                                        const currentDay = currentDate.getDay();

                                        if (currentDay === 1) {
                                            price = ((prices.valueMonday / 60) * p.setIntervalInMin).toString();
                                        } else if (currentDay === 2) {
                                            price = ((prices.valueTuesday / 60) * p.setIntervalInMin).toString();
                                        } else if (currentDay === 3) {
                                            price = ((prices.valueWednesday / 60) * p.setIntervalInMin).toString();
                                        } else if (currentDay === 4) {
                                            price = ((prices.valueThursday / 60) * p.setIntervalInMin).toString();
                                        } else if (currentDay === 5) {
                                            price = ((prices.valueFriday / 60) * p.setIntervalInMin).toString();
                                        } else if (currentDay === 6) {
                                            price = ((prices.valueSaturday / 60) * p.setIntervalInMin).toString();
                                        } else {
                                            price = ((prices.valueSunday / 60) * p.setIntervalInMin).toString();
                                        }

                                        let currencySymbol = "";

                                        if (self.culture === "da") {
                                            currencySymbol = " kr";
                                        } else if (self.culture === "en-GB") {
                                            currencySymbol = " $";
                                        } else if (self.culture === "sv") {
                                            currencySymbol = " sek";
                                        } else if (self.culture === "no") {
                                            currencySymbol = " nok";
                                        }

                                        var original = +price;

                                        var bookings = ((<any>window).bookCalendar && (<any>window).bookCalendar.daystatusService)
                                            ? (<any>window).bookCalendar.daystatusService.bookings as []
                                            : [];

                                        const filteredBookings = bookings.filter((booking: any) => {
                                            const arrivalDate = new Date(booking.arrivaldateRfc1123);
                                            const departureDate = new Date(booking.departuredateRfc1123);

                                            const isDateMatching = (
                                                arrivalDate.getDate() <= currentDate.getDate() ||
                                                departureDate.getDate() >= currentDate.getDate()
                                            );

                                            return isDateMatching && booking.type !== -20;
                                        });

                                        const intervalInMin = p.setIntervalInMin || 60;
                                        const totalIntervals = Math.ceil((hoursDiff * 60) / intervalInMin);
                                        const currentDateTime = new Date();

                                        for (let i = 0; i < totalIntervals; i++) {
                                            const currentHour = new Date(startTime.getTime() + i * intervalInMin * 60 * 1000);
                                            currentHour.setMilliseconds(0);

                                            const formattedHour = currentHour.toLocaleTimeString(self.culture, {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: false
                                            }).replace(".", ":");

                                            const intervalEndTime = new Date(currentHour.getTime() + intervalInMin * 60 * 1000);
                                            const isBetween = filteredBookings.some((booking: any) => {
                                                const _currentHour = currentHour;
                                                const arrivalDate = new Date(booking.arrivaldateRfc1123);
                                                const departureDate = new Date(booking.departuredateRfc1123);

                                                return _currentHour < departureDate && intervalEndTime > arrivalDate;
                                            });


                                            const isInThePast = currentDateTime >= intervalEndTime;

                                            let styling = isBetween || isInThePast ? 'disabled' : '';

                                            if (activeTimePeriods.length > 0) {
                                                var found = false;
                                                price = ((original / 60) * intervalInMin).toFixed(0) + currencySymbol;

                                                $.each(activeTimePeriods, function (i, e) {
                                                    var n = p.bookingtype.prices.filter(p => p.id == e.bookingTypeId);

                                                    if (n.length > 0) {
                                                        var _S = new Date(n[0].startdate);
                                                        var _E = new Date(n[0].enddate);
                                                        var isAllowed = _S.getTime() <= _currentDate.getTime() && _currentDate.getTime() <= _E.getTime();

                                                        if (e && e.timeFrom && e.timeTo && !found && isAllowed) {
                                                            const startDate = new Date(_currentDate.getFullYear(), _currentDate.getMonth(), _currentDate.getDate(), 0, 0, 0);
                                                            startDate.setDate(currentDate.getDate());

                                                            const [hours, minutes, seconds] = e.timeFrom.split(':');

                                                            startDate.setHours(Number(hours));
                                                            startDate.setMinutes(Number(minutes));
                                                            startDate.setSeconds(Number(seconds));
                                                            startDate.setMilliseconds(0);

                                                            const endDate = new Date(_currentDate.getFullYear(), _currentDate.getMonth(), _currentDate.getDate(), 0, 0, 0);
                                                            endDate.setDate(currentDate.getDate());

                                                            const [ehours, eminutes, eseconds] = e.timeTo.split(':');

                                                            endDate.setHours(Number(ehours));
                                                            endDate.setMinutes(Number(eminutes));
                                                            endDate.setSeconds(Number(eseconds));
                                                            endDate.setMilliseconds(0);

                                                            endDate.setMinutes(Number(-(intervalInMin - 1)));

                                                            if (startDate.getTime() <= currentHour.getTime() && currentHour.getTime() <= endDate.getTime()) {
                                                                price = ((e.price / 60) * intervalInMin) + currencySymbol;
                                                                found = true;
                                                            }
                                                        }
                                                    }
                                                });
                                            }

                                            let matchingInventory: any = null;
                                            if (p.inventorymanagementIsEffect) {
                                                matchingInventory = inventoryCapacities.filter((x: any) => {
                                                    const inventoryStart = new Date(x.datestart);
                                                    const inventoryEnd = new Date(x.dateend);

                                                    return currentHour < inventoryEnd && intervalEndTime > inventoryStart;
                                                }).sort((a: any, b: any) => a.available - b.available)[0];

                                                price = matchingInventory
                                                    ? matchingInventory.available.toString()
                                                    : "0";

                                                const minimumPersonCount = matchingInventory ? +(matchingInventory.minimumPersonCount || 0) : 0;
                                                if (+price < Math.max(1, minimumPersonCount)) {
                                                    styling = 'disabled';
                                                }
                                                if (+price <= 1 || +price < Math.max(1, minimumPersonCount)) {
                                                    price = ' ';
                                                }
                                            }

                                            const toLocalDateTimeString = (date: Date) => {
                                                const pad = (n: number) => n < 10 ? "0" + n : n;

                                                return date.getFullYear() + "-" +
                                                    pad(date.getMonth() + 1) + "-" +
                                                    pad(date.getDate()) + "T" +
                                                    pad(date.getHours()) + ":" +
                                                    pad(date.getMinutes()) + ":00.000";
                                            };


                                            const localDateValue = toLocalDateTimeString(currentHour);

                                            let disableReason = "";
                                            if (isBetween) {
                                                disableReason = "Optaget";
                                            } else if (isInThePast) {
                                                disableReason = "Tidspunktet er passeret";
                                            } else if (p.inventorymanagementIsEffect) {
                                                if (matchingInventory) {
                                                    const minimumPersonCount = +(matchingInventory.minimumPersonCount || 0);
                                                    if (+matchingInventory.available < Math.max(1, minimumPersonCount)) disableReason = (window as any).Bookhus.Localization.Standard.UI.Widgets.Bookingpossibilities.CapacityBelowMinimum;
                                                    else if (+matchingInventory.available == 1) disableReason = "Inventory: Kun 1 ledig";
                                                } else {
                                                    disableReason = "Inventory: Ingen data";
                                                }
                                            }

                                            const titleAttr = (p.isAdmin && disableReason) ? ` title="${disableReason}" data-reason="${disableReason}"` : "";

                                            times += `<div class="small-box ${styling}" data-fdate="${localDateValue}" data-date="${localDateValue}"${titleAttr}>
                                                <div class="time">${formattedHour}</div>
                                                <div class="price">${price}</div>
                                            </div>`;
                                        }

                                        if (isLastSundayOfMarchOrOctober(_currentDate)) {
                                            times = removeDuplicateBoxes(times);
                                        }

                                        if (!datesSelected.some(date => date === _currentDate.toISOString())) {
                                            datesSelected.push(_currentDate.toISOString());

                                            possibilitiesHtml += `
                            <div class="row border-top sort timeBooking" data-date="${currentDate.getTime()}" data-sortId="${p.bookingtype.id}">
                                <div class="col-md-12" style="position:relative">
                                    <div class="row">
                                        <div class="col-md-1">
                                            <span></span>
                                        </div>
                                        <div class="col-md-6 pl-0" style="max-width: 48%">
                                            <div class="chekInOut pt-3 font-size-1 mb-3 pl-4">
                                                <div class="d-flex justify-content-between flex-wrap">
                                                    <span class="pb-1"><i class="fa fa-sun-o mr-1"></i>${regional.dayNames[currentDate.getDay()]}</span>
                                                    <span class="pb-1 date"><i class="fa fa-calendar mr-1"></i> ${currentDate.formatDate(regional.dateFormat)}</span>
                                                    <span class="pb-1"><i class="fa fa-clock-o mr-1"></i> ${arrivaltime} - <i class="fa fa-clock-o mr-1"></i> ${departuretime}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-1 col-sm-12" style="position:unset;"><div class="pr-0 d-flex flex-column justify-content-center align-items-center font-size-1 absolute_">Timer</div></div>
                                        <div class="col-md-9 col-sm-12">
                                            <div class="_box-container"
                                                 data-internval="${intervalInMin}"
                                                 data-date="${currentDate.formatDate(regional.dateFormat)}"
                                                 data-minlength="${p.bookingtype.effectiveMinlength}"
                                                 data-maxlength="${p.bookingtype.effectiveMaxlength}">
                                                ${times}
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-sm-12">
                                            <div class="w-100 disable">${this.getButtonHtml(p)}</div>
                                            ${p.isAdmin
                                                    ? this.getButtonHtml({
                                                        ...p,
                                                        type: 2
                                                    })
                                                    : ''
                                                }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `;
                                        }
                                    }
                                }
                            };

                            var isPricePerHour = (<any>p.bookingtype).pricePerHour || false;

                            if (!isPricePerHour) {
                                possibilitiesHtml += `
                <div class="row border-top sort" data-sortId="${p.bookingtype.id}">
                    <div class="col-md-6">
                        <div class="row">
                            ${p.bookingtype.extraParameters.subscriptionNoBookingEnding ? '' :
                                        `<div class="col-2 pr-0 d-flex flex-column justify-content-center align-items-center font-size-1">
                                    <span class="font-weight-bold">${p.durationdays}</span> 
                                    <div>${p.durationdays == 1 ? (window as any).Bookhus.Localization.Standard.UI.GeneralText.Day : (window as any).Bookhus.Localization.Standard.UI.GeneralText.Days}</div>
                                </div>`
                                    }
                            <div class="col-10 ${p.bookingtype.extraParameters.subscriptionNoBookingEnding ? 'offset-2' : ''} pl-0">
                                <div class="chekInOut pt-3 connect-line font-size-1 mb-3 pl-4">
                                    <div class="mb-3">
                                        <div class="text-secondary pb-1 font-weight-bold">${p.bookingtype.arrivalText}</div>
                                        <div class="d-flex justify-content-between  flex-wrap">
                                            <span class="pb-1"><i class="fa fa-sun-o mr-1"></i> ${regional.dayNames[arrivaldate.getDay()]}</span>
                                            <span class="pb-1"><i class="fa fa-calendar mr-1"></i> ${arrivaldate.formatDate(regional.dateFormat)}</span>
                                            <span class="pb-1"><i class="fa fa-clock-o mr-1"></i> ${arrivaltime}</span>
                                        </div>
                                    </div>
                                    <div class="mb-2">
                                        <div class="text-secondary pb-1 font-weight-bold">${p.bookingtype.departureText}</div>
                                        <div class="d-flex justify-content-between flex-wrap">
                                            <span class="pb-1"><i class="fa fa-moon-o mr-1"></i> ${regional.dayNames[departuredate.getDay()]}</span>
                                            <span class="pb-1"><i class="fa fa-calendar mr-1"></i> ${departuredate.formatDate(regional.dateFormat)}</span>
                                            <span class="pb-1"><i class="fa fa-clock-o mr-1"></i> ${departuretime}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 d-flex flex-column justify-content-center">
                        <div class="row mb-3 mb-md-0">
                            <div class="col-6 col-sm-7 col-md-8 d-flex flex-column justify-content-end align-items-center">
                                ${this.showBookingType ? `<span class="font-size-1">${p.bookingtype.description}</span>` : ''}
                                ${p.calculatedPriceString}
                                <span class="text-warning font-size-1 align-self-start ml-0 ml-xl-5" style="max-width: 90%;">${p.notOpenYetText || ''}</span>
                            </div>
                            <div class="col-6 col-sm-5 col-md-4 pt-md-2 d-flex flex-column justify-content-center align-items-center">
                                ${this.getButtonHtml(p)}
                            </div>
                        </div>
                    </div>
                </div>
            `;
                            } else {
                                if (p.inventorymanagementIsEffect) {
                                    const key = `${p.arrivaldate}_${p.departuredate}`;

                                    const loadInventory = inventoryCache[key]
                                        ? $.Deferred().resolve(inventoryCache[key]).promise()
                                        : $.getJSON("/api/booking/GetInventoryCapacities", {
                                            houseId: self.houseId,
                                            start: formatDateTime(new Date(p.arrivaldate)),
                                            end: formatDateTime(new Date(p.departuredate))
                                        }).then((data) => {
                                            inventoryCache[key] = data;
                                            return data;
                                        });

                                    possibilityRequests.push(
                                        loadInventory.then((inventoryCapacities) => {
                                            runBookingLogic(inventoryCapacities);
                                        })
                                    );
                                } else {
                                    runBookingLogic();
                                }
                            }
                        });

                        $.when.apply($, possibilityRequests).always(() => {
                            if (self.activeRequestId !== requestId || self.pendingReload) {
                                return;
                            }
                            var result = `
            ${additionalMessage.length > 0 ? additionalMessage + '<br/>' : ''}
            ${possibilitiesHtml}
        `;

                            $("#" + self.containerId).html(result);
                        });
                    }

                    function addAllTimePeriods(htmlString, intervalInMin, totalIntervals) {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(htmlString, 'text/html');
                        const boxes = doc.querySelectorAll('.small-box');

                        // Assume the times are sorted; if not, sort them.
                        const times = Array.from(boxes).map(box => box.getAttribute('data-fdate')).sort();
                        if (times.length === 0) return htmlString;  // Return original if no times are found.


                        const startTimeString = times[0];
                        const endTimeString = times[times.length - 1];
                        let expectedTimes = [startTimeString];  // Start with the first time

                        let currentTimeString = startTimeString;

                        for (let i = 1; i < totalIntervals; i++) {
                            currentTimeString = incrementTimeString(currentTimeString, intervalInMin);
                            expectedTimes.push(currentTimeString);
                        }

                        expectedTimes.forEach(time => {
                            const standardizedTime = standardizeTimeString(time);
                            const isTimeIncluded = times.some(t => {
                                return standardizeTimeString(t) === standardizedTime;
                            });

                            if (!isTimeIncluded) {
                                const newBox = doc.createElement('div');
                                newBox.className = 'small-box';
                                newBox.setAttribute('data-fdate', time);
                                var p = standardizedTime.split(' ');
                                p = p[4].split(':');
                                newBox.innerHTML = `<div class="time">${p[0] + ":" + p[1]}</div><div class="price">300</div>`;
                                let inserted = false;
                                Array.from(doc.querySelectorAll('.small-box')).forEach(existingBox => {
                                    const existingTime = existingBox.querySelector('.time').textContent;
                                    if (!inserted && existingTime > `${p[0] + ":" + p[1]}`) {
                                        existingBox.parentNode.insertBefore(newBox, existingBox);
                                        inserted = true;
                                    }
                                });


                                if (!inserted) {
                                    doc.body.appendChild(newBox);
                                }
                            }
                        });

                        // Serialize back to HTML
                        const serializer = new XMLSerializer();
                        return serializer.serializeToString(doc.body).replace(/<\/?body>/g, '');
                    }

                    function standardizeTimeString(timeStr) {
                        // Split the time string by spaces to isolate parts
                        const parts = timeStr.split(' ');
                        //console.log(parts)

                        // Reconstruct the string without the seconds part (assumes seconds are always at a fixed index if present)
                        // Typical format: Sun Mar 30 2025 00:00:00 GMT+0100 (Central European Standard Time)
                        // We want to ignore the seconds part which is index 4 if it exists
                        if (parts.length > 5 && parts[4].includes(':')) {
                            // Join the parts up to the timezone
                            return parts.slice(0, 5).join(' ') + (parts[4].split(':').length > 2 ? "" : ":00");
                        } else if (parts.length > 4) {
                            // Handle case where the time might not include seconds by formatting with "00" for seconds
                            // Assuming parts[4] would be the timezone if seconds are missing
                            return `${parts.slice(0, 4).join(' ')}:00 ${parts[4]}`;
                        }
                        return timeStr; // Return the original if it doesn't match expected format or no seconds
                    }



                    function incrementTimeString(timeString, intervalInMin) {
                        const parts = timeString.split(' ');
                        let [hours, minutes] = parts[4].split(':');
                        minutes = parseInt(minutes) + intervalInMin;
                        if (minutes >= 60) {
                            minutes -= 60;
                            hours = parseInt(hours) + 1;
                            if (hours < 10) hours = '0' + hours;
                            if (hours >= 24) hours = '00'; // Handle midnight wrap-around
                        }
                        if (minutes < 10) minutes = '0' + minutes;
                        parts[4] = `${hours}:${minutes}`;
                        return parts.join(' ');
                    }

                    function removeDuplicateBoxes(htmlString) {
                        // Create a DOMParser to turn the HTML string into a document object
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(htmlString, 'text/html');

                        // Use a Set to track unique dates
                        const seenDates = new Set();
                        const boxes = doc.querySelectorAll('.small-box'); // Select all boxes in the parsed document

                        // Iterate over the boxes to remove duplicates
                        boxes.forEach(box => {
                            const date = box.getAttribute('data-fdate');
                            if (seenDates.has(date)) {
                                // If the date has already been seen, remove this box from the parsed document
                                box.parentNode.removeChild(box);
                            } else {
                                // Otherwise, add the date to the set of seen dates
                                seenDates.add(date);
                            }
                        });

                        // Serialize the document back to an HTML string
                        const serializer = new XMLSerializer();
                        const serializedHtml = serializer.serializeToString(doc.body);
                        // Remove the extra <body> tags added by DOMParser
                        return serializedHtml.replace(/<\/?body>/g, '');
                    }

                    function isLastSundayOfMarchOrOctober(date) {
                        const month = date.getMonth(); // Get the month of the date (0-indexed, 0 = January, 9 = October)
                        const year = date.getFullYear(); // Get the year of the date

                        // Check if the month is March (2) or October (9)
                        if (month === 2 || month === 9) {
                            const lastDayOfMonth = new Date(year, month + 1, 0); // Get the last day of the month
                            const dayOfWeek = lastDayOfMonth.getDay(); // Get the day of the week (0 = Sunday, 6 = Saturday)

                            // Calculate the last Sunday of the month
                            let lastSunday = new Date(lastDayOfMonth);
                            lastSunday.setDate(lastDayOfMonth.getDate() - dayOfWeek); // Adjust to the previous Sunday if not already a Sunday

                            // Check if the given date is the same as the last Sunday
                            return date.getDate() === lastSunday.getDate() && date.getMonth() === lastSunday.getMonth() && date.getFullYear() === lastSunday.getFullYear();
                        }
                        return false; // Not March or October
                    }

                    $('#' + self.containerId + ' .disable').each(function () {
                        $(this).find("input[type=submit]").prop("disabled", true);
                    });

                    $.getJSON("/api/booking/GetHouseTypeId?Houseid=" + self.houseId).done((_data) => {
                        var typeId = _data.data.data;

                        $.getJSON("/admin/prices/GetHouseBookingTypeOrder?Houseid=" + self.houseId + "&HouseTypeId=" + typeId).done((data) => {
                            var ids = data.bookingId;
                            var divElements = $('#' + self.containerId + ' .sort');

                            if (ids && ids.length > 0) {
                                divElements.sort(function (a, b) {
                                    var aId = $(a).data('sortid');
                                    var bId = $(b).data('sortid');

                                    var aIndex = ids.indexOf(parseInt(aId));
                                    var bIndex = ids.indexOf(parseInt(bId));

                                    var aIdExists = aIndex !== -1;
                                    var bIdExists = bIndex !== -1;

                                    if (aIdExists && !bIdExists) {
                                        return -1;
                                    } else if (!aIdExists && bIdExists) {
                                        return 1;
                                    } else {
                                        return aIndex - bIndex;
                                    }
                                });
                            }

                            ids?.forEach(sortId => {
                                var groupElements = divElements.filter((_, el) => $(el).data('sortid') == sortId);
                                groupElements.sort(function (a, b) {
                                    return +$(a).attr('data-date') - +$(b).attr('data-date');
                                });
                            });

                            var parentContainer = $('#' + self.containerId);
                            divElements.appendTo(parentContainer);
                        });

                        $('#' + self.containerId + ' .submitWaitingList').off('click').on('click', function (e) {
                            e.preventDefault();
                            var $button = $(e.target);
                            var queueLength = $button.data('queuelength');

                            swal.fire({
                                html: self.queueListDefaultText.replace('{queuelength}', queueLength),
                                icon: 'question',
                                showConfirmButton: 'true',
                                confirmButtonText: (window as any).Bookhus.Localization.Standard.UI.ButtonText.Create,
                                showCancelButton: 'true',
                                cancelButtonText: (window as any).Bookhus.Localization.Standard.UI.ButtonText.Cancel,
                                showDenyButton: true,
                                denyButtonText: (window as any).Bookhus.Localization.Standard.UI.ButtonText.CreateAndGoToMyPage
                            }).then(function (result) {
                                if (result.isConfirmed || result.isDenied) {
                                    var $form = $button.parents('form:first');
                                    if ($form) {
                                        if (result.isDenied) {
                                            var input = $("<input>").attr("type", "hidden").attr("name", "mypage").val("true");
                                            $form.append(input);
                                        }
                                        $form.submit();
                                    }
                                }
                            });
                        });
                    });

                })
                .fail((jqxhr, textStatus, error) => {
                    if (self.activeRequestId === requestId && !self.pendingReload) {
                        $("#status").html(error)
                            .css('text-align', 'center')
                            .css('margin-bottom', '10px');
                        $("#" + this.containerId).html("");
                    }
                })
                .always(() => {
                    if (self.activeRequestId === requestId) {
                        self.isReloading = false;
                        if (self.pendingReload) {
                            const pending = self.pendingReload;
                            self.pendingReload = null;
                            self.reload(pending.startdate, pending.enddate);
                        }
                    }
                });
        }
    }
}
